import { buildOrgRoutePath } from '@/utils/routes';

export const resolveAnalyticsOrganizationId = (
  routeOrganizationId?: string | null,
  selectedOrganizationId?: string | null,
): string | null => routeOrganizationId || selectedOrganizationId || null;

export const buildAnalyticsListPath = (
  routeOrganizationId?: string | null,
  selectedOrganizationId?: string | null,
): string => {
  const organizationId = resolveAnalyticsOrganizationId(
    routeOrganizationId,
    selectedOrganizationId,
  );
  return organizationId ? buildOrgRoutePath('/analytics', organizationId) : '/';
};

export const buildAnalyticsAgentDetailPath = (organizationId: string, agentId: string): string =>
  buildOrgRoutePath(`/analytics/agents/${agentId}`, organizationId);

// metric_key is a scorecard string that commonly contains a "." (e.g.
// "content.refill_status"); encode it so it stays a single, safe path segment.
export const buildAnalyticsQuestionDetailPath = (
  organizationId: string,
  metricKey: string,
): string =>
  buildOrgRoutePath(`/analytics/questions/${encodeURIComponent(metricKey)}`, organizationId);
